export const StreamingClients = {
  GUACAMOLE: "guacamole",
  WEBRTC: "webrtc"
};

export const TestStates = {
  BROWSER_PROFILE: "browserprofile",
  CONFIGURING: "configuring",
  DATA_NOT_AVAILABLE: "Data Not Available",
  MACHINE_BUSY: "All machines seems to be busy, please try after some time",
  SESSION_EXPIRED: "session-expired",
  TAKE_OFF: "takeoff"
};

export const TransceiverOptions = {
  receive: true,
  send: false
};

export const StreamTypes = { AUDIO: "audio", VIDEO: "video" };

export const IceConnectionStates = {
  CLOSED: "closed",
  CONNECTED: "connected",
  DISCONNECTED: "disconnected",
  FAILED: "failed",
  NEW: "new"
};

export const VideoOpacities = {
  CONNECTED: "1",
  DISCONNECTED: "0.25",
  FAILED: "0.25"
};

export const IceGatheringState = {
  COMPLETE: "complete"
};

export const DataChannelTypes = {
  CLIENT: "ClientDataChannel"
};

export const WHEEL_STEP = 50; // Pixels needed for one step
export const WHEEL_LINE_HEIGHT = 19; // Assumed pixels for one line step

export const MouseEvents = {
  CLICK: "click",
  CONTEXT_MENU: "contextmenu",
  DOWN: "mousedown",
  MOVE: "mousemove",
  UP: "mouseup",
  WHEEL: "wheel"
};

// Minimum wait (ms) between two mouse moves
export const MOUSE_MOVE_DELAY = 17;

export const KeyboardEvents = {
  BLUR: "blur",
  COPY: "copy",
  DOWN: "keydown",
  PASTE: "paste",
  UP: "keyup"
};
